var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12 d-flex justify-content-end align-items-center" },
        [
          !_vm.onlyActionButton
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadedTemplate.name,
                      expression: "loadedTemplate.name",
                    },
                  ],
                  staticClass:
                    "mr-3 align-items-center loaded-template-text h-100",
                },
                [
                  _c(
                    "h5",
                    {
                      staticClass:
                        "font-sm mb-0 bold font-italic text-truncate",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("automations.boardLevel.usingTemplate")
                          ) +
                          ":\n        "
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "font-weight-normal text-gray ml-2 loaded-template-name",
                        },
                        [_vm._v(_vm._s(_vm.loadedTemplate.name))]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.onlyActionButton
            ? _c(
                "div",
                { staticClass: "dropdown h-100" },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-primary clickable dropdown-toggle btn-sm mr-2",
                      attrs: {
                        id: _vm.storedEmailsDropdownId,
                        role: "button",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$tc("campaigns.emailTemplate", 2)))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      attrs: { "aria-labelledby": "dropdownMenuLink" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "email-template-new-actions",
                          attrs: { id: "dropdownMenuLink" },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item clickable save-email-template",
                              class: { disabled: !_vm.rawHtml },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleSaveAsNewClick.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.loadedTemplate.name
                                      ? _vm.$t("global.actions.saveAsNew")
                                      : _vm.$t("global.actions.saveEmailInView")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.template-email-modal",
                                  modifiers: { "template-email-modal": true },
                                },
                              ],
                              staticClass:
                                "dropdown-item clickable load-email-template-list",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.loadedTemplate.name
                                      ? _vm.$t(
                                          "automations.boardLevel.loadAnotherTemplate"
                                        )
                                      : _vm.$t(
                                          "automations.boardLevel.loadEmailTemplate"
                                        )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.loadedTemplate.name,
                              expression: "loadedTemplate.name",
                            },
                          ],
                          staticClass: "email-template-edit-actions",
                        },
                        [
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item clickable edit-email-template",
                              on: { click: _vm.handleUpdateTemplate },
                            },
                            [_vm._v(_vm._s(_vm.$t("global.words.update")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item clickable clear-email-template-list",
                              on: { click: _vm.clearTemplate },
                            },
                            [_vm._v(_vm._s(_vm.$t("global.words.clear")))]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target: _vm.storedEmailsDropdownId,
                        triggers: "manual",
                        show: _vm.showSaveWithAttachmentsPopover,
                        placement: "bottom",
                        "custom-class": "inline-prompt",
                      },
                      on: {
                        "update:show": function ($event) {
                          _vm.showSaveWithAttachmentsPopover = $event
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-column" }, [
                        _c("span", { staticClass: "text-gray mb-2" }, [
                          _vm._v(
                            _vm._s(_vm.$t("email.actions.includeAttachments"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center",
                          },
                          [
                            _c(
                              "simple-button",
                              {
                                attrs: {
                                  type: "button",
                                  "class-name":
                                    "prompt-link accept-link clickable btn-sm",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSaveWithAttachments(true)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.words.yes")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link btn-sm ml-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSaveWithAttachments(false)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.words.no")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _c("template-email-modal", {
        attrs: { "email-templates": _vm.templates },
        on: {
          select: _vm.handleTemplateSelect,
          delete: _vm.handleTemplateDelete,
        },
      }),
      _vm._v(" "),
      _c("save-template-modal", {
        ref: "saveTemplateModal",
        attrs: {
          "loaded-template": _vm.loadedTemplate,
          "save-as-new": _vm.saveAsNew,
          html: _vm.rawHtml,
          subject: _vm.subject,
          attachments: _vm.getAttachments,
          "saving-template": _vm.savingTemplate,
        },
        on: {
          save: _vm.saveTemplate,
          hide: function ($event) {
            return _vm.clearAfterHide(false)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }